import React from "react";
import { Badge } from "react-bootstrap";
import {
  FaUniversity, FaIdCard, FaInfoCircle, FaGlobe
} from "react-icons/fa";
import GenericCrudPage from '../components/GenericCrudPage'; // Assuming this path is correct

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Validation for university form
const validateUniversityForm = (form) => {
  const errors = {};
  if (!form.name.trim()) errors.name = "University name is required";
  if (form.name.length > 100) errors.name = "University name must be less than 100 characters";
  if (!form.identifier.trim()) errors.identifier = "Identifier is required";
  return errors;
};

// Configuration for University CRUD operations
const universityConfig = {
  baseUrl: BASE_URL,
  endpoints: {
    fetch: '/master/getUniversity',
    save: '/master/saveUniversity',
    update: '/master/updateUniversity',
    delete: '/master/deleteUniversity'
  },
  validateForm: validateUniversityForm,
  initialFormState: {
    name: "", identifier: "", description: "", localLangName: "", isActive: 1, user: ""
  },
  entityName: 'University'
};

// Form fields configuration
const formFields = [
  { name: "name", label: "University Name", icon: FaUniversity, required: true },
  { name: "identifier", label: "Identifier Code", icon: FaIdCard, required: true },
  { name: "localLangName", label: "Local Language Name", icon: FaGlobe },
  { name: "description", label: "Description", icon: FaInfoCircle, as: "textarea", rows: 3 },
];

// Table columns configuration
const tableColumns = [
  {
    key: 'exName',
    label: 'University Name',
    sortable: true,
    render: (university) => (
      <div>
        <div className="fw-bold">{university.exName}</div>
        <div className="text-muted small">{university.exLocalLangName || 'No local name'}</div>
      </div>
    )
  },
  {
    key: 'exIdentifier',
    label: 'Identifier',
    sortable: true,
    render: (university) => (
      <Badge bg="info-subtle" text="info-emphasis" className="font-monospace">
        {university.exIdentifier}
      </Badge>
    )
  },
  { key: 'exDescription', label: 'Description', sortable: true, className: "text-truncate", style: { maxWidth: '250px' } }
];

// CSV export headers
const csvHeaders = [
  { key: 'exName', label: 'Name' },
  { key: 'exIdentifier', label: 'Identifier' },
  { key: 'exDescription', label: 'Description' },
  { key: 'exLocalLangName', label: 'Local Language Name' },
  { key: 'exIsActive', label: 'Status' }
];

// Transform form data to API payload
const transformPayload = (form, editId) => ({
  exName: form.name.trim(),
  exIdentifier: form.identifier.trim(),
  exDescription: form.description.trim(),
  exLocalLangName: form.localLangName.trim(),
  exIsActive: form.isActive,
  user: form.user.trim(),
  ...(editId && { id: editId })
});

// Transform API data to form
const transformToForm = (university) => ({
  name: university.exName || "",
  identifier: university.exIdentifier || "",
  description: university.exDescription || "",
  localLangName: university.exLocalLangName || "",
  isActive: university.exIsActive,
  user: university.user || "",
});

// Get view modal fields
const getViewFields = (university) => {
  if (!university) return [];
  return [
    { label: "University Name", value: university.exName, icon: FaUniversity },
    { label: "Identifier", value: university.exIdentifier, icon: FaIdCard },
    { label: "Local Language Name", value: university.exLocalLangName, icon: FaGlobe },
    { label: "Description", value: university.exDescription, icon: FaInfoCircle, fullWidth: true },
  ];
};

export default function UniversityPage() {
  return (
    <GenericCrudPage
      title="Universities"
      config={universityConfig}
      formFields={formFields}
      tableColumns={tableColumns}
      emptyIcon={FaUniversity}
      searchPlaceholder="Search by name, identifier, description..."
      csvHeaders={csvHeaders}
      csvFilename="universities_export.csv"
      transformPayload={transformPayload}
      transformToForm={transformToForm}
      getViewFields={getViewFields}
    />
  );
}